const CoursesPage = () => (
  <div className="p-8 bg-white rounded-lg shadow-xl">
    <h2 className="text-3xl font-bold text-gray-800 mb-6">Our Yoga Courses</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-200">
        <h3 className="text-2xl font-semibold text-gray-700 mb-3">
          Hatha Yoga
        </h3>
        <p className="text-gray-600">
          Focuses on basic poses and breathing. Great for beginners to build
          strength and flexibility.
        </p>
      </div>
      <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-200">
        <h3 className="text-2xl font-semibold text-gray-700 mb-3">
          Vinyasa Flow
        </h3>
        <p className="text-gray-600">
          Dynamic sequences linking breath to movement. Builds heat, endurance,
          and flexibility.
        </p>
      </div>
      <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-200">
        <h3 className="text-2xl font-semibold text-gray-700 mb-3">
          Restorative Yoga
        </h3>
        <p className="text-gray-600">
          Gentle, slow-paced practice using props to support the body, promoting
          deep relaxation.
        </p>
      </div>
      <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-200">
        <h3 className="text-2xl font-semibold text-gray-700 mb-3">
          Ashtanga Yoga
        </h3>
        <p className="text-gray-600">
          A rigorous, physically demanding practice with a set sequence of
          poses.
        </p>
      </div>
      <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-200">
        <h3 className="text-2xl font-semibold text-gray-700 mb-3">
          Prenatal Yoga
        </h3>
        <p className="text-gray-600">
          Safe and supportive practice designed for expectant mothers to prepare
          for childbirth.
        </p>
      </div>
      <div className="bg-gray-50 p-6 rounded-lg shadow-md border border-gray-200">
        <h3 className="text-2xl font-semibold text-gray-700 mb-3">
          Meditation & Pranayama
        </h3>
        <p className="text-gray-600">
          Classes focused on breathing exercises and mindfulness techniques for
          mental clarity.
        </p>
      </div>
    </div>
  </div>
);

export default CoursesPage;
